// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-499bdf6c]:export {\n  menuBg: #b58643;\n  menuText: #e0e0e0;\n  menuActiveText: #ffe164;\n  menuActiveBg: #906a35;\n}\n\n/* Mixins */\n.el-tag[data-v-499bdf6c] {\n  margin-right: 4px;\n}\n.input-new-tag[data-v-499bdf6c] {\n  width: 100px;\n}", ""]);
// Exports
module.exports = exports;
